import { useCallback, useEffect, useState } from 'react';
import { parentApi } from '../services/parentApi';
import { reportSupervisedCount } from '../supervisionStatus';

export function useParentStudents() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await parentApi.listStudents({});
      setStudents(Array.isArray(data?.students) ? data.students : []);
    } catch (e) {
      setError(e?.message || 'Failed to load students.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  // This screen already holds the authoritative list, so it feeds the shell's
  // supervision store rather than making it fetch a second copy. Covers the
  // initial load, linking a first student (Parents nav item appears), and
  // unlinking the last one.
  useEffect(() => {
    if (!loading && !error) reportSupervisedCount(students.length);
  }, [students.length, loading, error]);

  const linkStudent = useCallback(async (code) => {
    const res = await parentApi.linkStudent({ code });
    const newStudent = res?.student;
    if (newStudent) {
      setStudents((prev) => [newStudent, ...prev.filter((s) => s.studentId !== newStudent.studentId)]);
    }
    return newStudent;
  }, []);

  const unlinkStudent = useCallback(async (studentId) => {
    await parentApi.unlinkStudent({ studentId });
    setStudents((prev) => prev.filter((s) => s.studentId !== studentId));
  }, []);

  return { students, loading, error, reload: load, linkStudent, unlinkStudent };
}
